/* Nela stock line: real stock per variant + countdown to the real dispatch cut-off (Mon–Fri). */
(function () {
  var el = document.querySelector('[data-n-stock]');
  if (!el) return;
  var T = el.querySelector('[data-n-text]').dataset;
  var map = {};
  try { map = JSON.parse(el.querySelector('[data-n-variants]').textContent); } catch (e) {}
  var pill = el.querySelector('[data-n-label]'), note = el.querySelector('[data-n-note]'), dot = el.querySelector('.n-stock__dot'), msg = el.querySelector('[data-n-msg]');
  var cutoff = parseInt(el.dataset.cutoff, 10) || 17, tz = el.dataset.tz, showCd = el.dataset.countdown === 'true';
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var current = null;

  function nowIn(zone) {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: zone, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { d: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday), h: +p.hour, m: +p.minute };
  }
  function dispatchText() {
    var n = nowIn(tz), mins = cutoff * 60 - (n.h * 60 + n.m);
    if (n.d > 0 && n.d < 6 && mins > 0) {
      var h = Math.floor(mins / 60), m = mins % 60;
      return T.today.replace('[time]', '<b>' + (h ? h + 'h ' : '') + m + 'm</b>');
    }
    var next = (n.d + 1) % 7; while (next === 0 || next === 6) next = (next + 1) % 7;
    var tomorrow = next === (n.d + 1) % 7;
    return T.later.replace('[day]', '<b>' + (tomorrow ? 'tomorrow' : days[next]) + '</b>');
  }
  function render() {
    var v = map[current] || [true, 0], ok = v[0], low = v[1];
    dot.className = 'n-stock__dot' + (!ok ? ' is-out' : low > 0 ? ' is-low' : '');
    pill.textContent = !ok ? T.out : low > 0 ? T.low.replace('[count]', low) : T['in'];
    if (note) note.textContent = ok && !low ? T.note : '';
    msg.innerHTML = !ok ? T.outSub : showCd ? dispatchText() : '';
  }
  function sync() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = (input && input.value) || new URLSearchParams(location.search).get('variant') || Object.keys(map)[0];
    if (id !== current) { current = id; render(); }
  }
  sync(); render();
  document.addEventListener('change', function () { setTimeout(sync, 60); });
  document.addEventListener('click', function () { setTimeout(sync, 60); });
  setInterval(function () { if (!document.hidden) render(); }, 30000);
})();
